"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPage = void 0;
var React = require("react");
var react_northstar_1 = require("@fluentui/react-northstar");
require("./errorPage.scss");
var error_1 = require("../communication/error");
var illustration_1 = require("../communication/illustration");
var ErrorPage = /** @class */ (function (_super) {
    __extends(ErrorPage, _super);
    function ErrorPage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            message: null
        };
        return _this;
    }
    ErrorPage.prototype.componentDidMount = function () {
        var params = this.props.match.params;
        if ('message' in params) {
            this.setState({
                message: params['message']
            });
        }
    };
    ErrorPage.prototype.render = function () {
        return (React.createElement(react_northstar_1.Flex, null,
            React.createElement(react_northstar_1.Flex, { vAlign: "center", hAlign: "center", styles: {
                    width: "100%",
                    height: "100vh",
                } },
                React.createElement(react_northstar_1.Flex, { hAlign: "center", gap: "gap.large", column: true, style: {
                        width: "100%",
                        maxWidth: "40.5rem",
                        margin: "3rem 1.25rem",
                        height: "55rem"
                    } },
                    React.createElement(illustration_1.Illustration, { option: error_1.ERROR_ILLUSTRATIONS.teamsTheme }),
                    React.createElement(react_northstar_1.Text, { size: "larger", content: "Algo deu errado." }),
                    React.createElement(react_northstar_1.Text, { align: "center", content: "Por favor, entre em contato com o administrador do sistema." }),
                    this.state.message &&
                        React.createElement(react_northstar_1.Text, { align: "center", content: "(" + this.state.message + ")" })))));
    };
    return ErrorPage;
}(React.Component));
exports.ErrorPage = ErrorPage;
;
exports.default = ErrorPage;
//# sourceMappingURL=errorPage.js.map